<p-dialog
  #detalhesPedido
  [modal]="true"
  [visible]="true"
  [position]="'top'"
  (visibleChange)="matDialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="width-100 ml-4 mt-2 flex flex-column">
      <h4 class="fs-normal ml-1">Detalhes do pedido Nº {{ pedido.numero }}</h4>
      <span *ngIf="pedido.orcamento_numero">
        Originado pelo orçamento Nº {{ pedido.orcamento_numero }}
      </span>
    </div>
  </ng-template>
  <mat-tab-group>
    <mat-tab label="Dados">
      <div class="m-0 row width-100 flex flex-column">
        <div class="flex align-items-center">
          <i class="pi pi-clock pi-spin text-orange-500 mr-1"></i>
          <div
            class="flex aling-items-center justify-content-between width-100"
          >
            <p>Criado em:</p>
            <p>
              {{ pedido.created_at | date: 'shortDate' }} -
              {{ pedido.created_at | date: 'shortTime' }}
            </p>
          </div>
        </div>
        <div class="flex align-items-center">
          <i class="pi pi-clock pi-spin text-orange-500 mr-1"></i>
          <div
            class="flex aling-items-center justify-content-between width-100"
          >
            <p>Entrou em produção:</p>
            <p
              *ngIf="
                !(
                  pedido.status === 'CONCLUIDO' || pedido.status === 'CANCELADO'
                )
              "
            >
              {{ eventoProducao.status_dh | date: 'shortDate' }} -
              {{ eventoProducao.status_dh | date: 'shortTime' }}
            </p>
            <p *ngIf="pedido.status === 'CONCLUIDO'">
              <b>Pedido concluído!</b>
            </p>
            <p *ngIf="pedido.status === 'CANCELADO'">
              <b>Pedido cancelado!</b>
            </p>
          </div>
        </div>
        <div class="flex align-items-center">
          <i class="pi pi-user text-primary mr-1"></i>
          <div
            class="flex aling-items-center justify-content-between width-100"
          >
            <p>Responsável por encaminhar para produção:</p>
            <p>
              {{ eventoProducao.user.name | uppercase }}
            </p>
          </div>
        </div>
        <div class="flex align-items-center">
          <i class="pi pi-calendar text-primary mr-1"></i>
          <div
            class="flex aling-items-center justify-content-between width-100"
          >
            <p>Data de solicitação:</p>
            <p>
              {{ pedido.data_hora | date: 'shortDate' }}
            </p>
          </div>
        </div>
        <div class="flex align-items-center">
          <i class="pi pi-calendar text-primary mr-1"></i>
          <div
            class="flex aling-items-center justify-content-between width-100"
          >
            <p>Previsão de entrega:</p>
            <p>
              {{ pedido.previsao_entrega | date: 'shortDate' }}
            </p>
          </div>
        </div>
        <!-- <div class="flex align-items-center">
              <i class="pi pi-shopping-cart text-primary mr-1"></i>
              <div
                class="flex aling-items-center justify-content-between width-100"
              >
                <p>Pedidos relacionados:</p>
                <p>
                  {{ getPedidosRelacionados() }}
                </p>
              </div>
            </div> -->

        <p-divider></p-divider>

        <div class="flex align-items-center">
          <i class="pi pi-user text-primary mr-1"></i>
          <div
            class="flex aling-items-center justify-content-between width-100"
          >
            <p>Cliente:</p>
            <p>
              {{ pedido.pre_cadastro_nome_razao_social }}
            </p>
          </div>
        </div>
        <div class="flex align-items-center">
          <i class="pi pi-user text-primary mr-1"></i>
          <div
            class="flex aling-items-center justify-content-between width-100"
          >
            <p>Vendedor:</p>
            <p>
              {{ pedido.vendedor_apelido_nome_fantasia }}
            </p>
          </div>
        </div>
        <div class="flex align-items-center">
          <i class="mdi mdi-alphabetical-variant text-primary mr-1"></i>
          <div
            class="flex aling-items-center justify-content-between width-100"
          >
            <p>Referência:</p>
            <p>
              {{ pedido.referencia }}
            </p>
          </div>
        </div>
        <div class="flex align-items-center">
          <i class="mdi mdi-shape-outline text-primary mr-1"></i>
          <div
            class="flex aling-items-center justify-content-between width-100"
          >
            <p>Modelo:</p>
            <p>
              {{ pedido.modelo_descricao }}
            </p>
          </div>
        </div>
        <div class="flex align-items-center">
          <i class="mdi mdi-hammer-wrench text-primary mr-1"></i>
          <div
            class="flex aling-items-center justify-content-between width-100"
          >
            <p>Linha de montagem:</p>
            <p>
              {{ pedido.linha_montagem_descricao }}
            </p>
          </div>
        </div>
        <div class="flex align-items-center">
          <i class="pi pi-search text-primary mr-1"></i>
          <div
            class="flex aling-items-center justify-content-between width-100"
          >
            <p>Localizador:</p>
            <p>
              {{ pedido.localizador ?? 'Sem localizador!' }}
            </p>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Observação" *ngIf="pedido.observacao">
      <div class="flex align-items-center">
        <i class="mdi mdi-clipboard-text-search-outline text-primary mr-1"></i>
        Observação:
      </div>
      <p class="content-obs">{{ pedido.observacao }}</p>
    </mat-tab>
  </mat-tab-group>
</p-dialog>
